import React, { FC } from 'react';
import { currentUserVar } from 'apollo/reactive-variables/user';
import InvoicingForTechnician from './invoicing-for-technician.component';
import { permissions } from 'utils/permission';
import InvoicingForDentist from './invoicing-for-dentist.component';

const ManageInvoices: FC = () => {
    const currentUser = currentUserVar();
    return permissions.isLabTechnician(currentUser.type) ? <InvoicingForTechnician /> : <InvoicingForDentist />;
};

export default ManageInvoices;
